import { render, staticRenderFns } from "./UserScoreList.vue?vue&type=template&id=86a61ce8&scoped=true"
import script from "./UserScoreList.vue?vue&type=script&lang=js"
export * from "./UserScoreList.vue?vue&type=script&lang=js"
import style0 from "./UserScoreList.vue?vue&type=style&index=0&id=86a61ce8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a61ce8",
  null
  
)

export default component.exports